import { useEffect, useState } from 'react'
import { isClient } from '@cred/shared/utils'

const useViewport = () => {
  const getWidth = () => isClient ? window.innerWidth : undefined,
    [width, setWidth] = useState(getWidth())

  useEffect(() => {
    const handleWindowResize = () => setWidth(getWidth())

    window.addEventListener('resize', handleWindowResize)
    return () => window.removeEventListener('resize', handleWindowResize)
  }, [])

  return width
}

export { useViewport }
